<app-page-header-bar dialog justify-content="center">
	{{pageHeading()}}
</app-page-header-bar>

<mat-dialog-content class="custom-scrollbar">
	<form (ngSubmit)="saveInteraction()" [formGroup]="form">

		@if (data.showRelationshipPicker) {
			<section class="relationship" aria-labelledby="relationship-details-title">
				<h2 id="relationship-details-title">Relationship</h2>

				<mat-form-field hintLabel="Who did you interact with?" appearance="outline" floatLabel="auto">
					<mat-label>Name of person</mat-label>
					<select formControlName="idOfRelationship" required matNativeControl>
						@for (relationship of relationships(); track relationship._id) {
							<option [value]="relationship._id">{{relationship.firstName}} {{relationship.lastName}}</option>
						}
					</select>
					@if (form.controls.idOfRelationship.hasError('required')) {
						<mat-error>Relationship is required</mat-error>
					}
				</mat-form-field>
			</section>
		}

		<section class="interaction-details" aria-labelledby="interaction-details-title">
			<h2 id="interaction-details-title">Interaction Details</h2>

			<mat-form-field appearance="outline" floatLabel="auto">
				<mat-label>Type of interaction</mat-label>
				<select formControlName="type" required matNativeControl>
					<option [value]="typeOptions.PhoneCall">Phone Call</option>
					<option [value]="typeOptions.Text">Text</option>
					<option [value]="typeOptions.Email">Email</option>
					<option [value]="typeOptions.InPerson">In Person</option>
					<option [value]="typeOptions.VideoCall">Video Call</option>
					<option [value]="typeOptions.GameChat">Game Chat</option>
					<option [value]="typeOptions.PostalMail">Postal Mail</option>
					<option [value]="typeOptions.SocialMedia">Social Media</option>
					<option [value]="typeOptions.VoiceMail">Voice Mail</option>
					<option [value]="typeOptions.Other">Other</option>
				</select>
				@if (form.controls.type.hasError('required')) {
					<mat-error>Interaction type is required</mat-error>
				}
			</mat-form-field>

			<mat-form-field appearance="outline" floatLabel="auto">
				<mat-label>Date</mat-label>
				<input matInput [matDatepicker]="datePicker" formControlName="date" [max]="dateMax" required>
				<mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
				<mat-datepicker #datePicker></mat-datepicker>
				@let date = form.controls.date;
				@if (date.hasError('required')) {
					<mat-error>Date is required</mat-error>
				} @else if (date.hasError('matDatepickerMax')) {
					<mat-error>Date cannot be in the future</mat-error>
				}
			</mat-form-field>
		</section>

		<section class="topics" aria-labelledby="topics-title">
			<h2 id="topics-title">Topics Discussed</h2>

			<button class="add-topic" (click)="addTopic()" mat-button type="button">Add Topic</button>

			@let topics = form.controls.topics;
			@if (topics.length) {
				@for (topic of topics.controls; track topic; let index = $index) {
					<app-card
						[topic]="topic | topicFormToModel"
						always-show-left-text
						(edit-topic)="editTopic(index)"
						(delete-topic)="deleteTopic(topic.value.name!, index)"
						[open]="false"
						collapsible
						scrollable-body
						hide-footer
					>
						<span [innerHTML]="topic.value.notes | newlinesToBr"></span>
					</app-card>
				}
			} @else {
				Once you add a topic, it will appear here along with any notes you've written.
			}
		</section>

	</form>
</mat-dialog-content>

<mat-dialog-actions>
	<button [mat-dialog-close]="{ wasCancelled: true }" mat-button>Cancel</button>
	@if (wasInteractionModified()) {
		<button (click)="saveInteraction()" mat-button>Save</button>
	}
</mat-dialog-actions>
